// Casca de modal compartilhada do modulo Faturamento.
// `overflow-auto` aqui é o ÚNICO container de rolagem — os filhos não devem ter o seu próprio.
const Modal = ({ title, subtitle, onClose, footer, children, maxW = 'max-w-3xl', closeOnBackdrop = true }) => (
    <div className='fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6'>
        <div className='fixed inset-0 bg-black bg-opacity-50' onClick={closeOnBackdrop ? onClose : undefined} />
        <div className={`relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full ${maxW} max-h-[90vh] flex flex-col transition-[max-width] duration-200`}>
            <div className='px-6 py-4 border-b border-gray-200 dark:border-gray-700'>
                <h2 className='text-xl font-bold text-gray-900 dark:text-white'>{title}</h2>
                {subtitle && <div className='text-sm text-gray-600 dark:text-gray-400 mt-1'>{subtitle}</div>}
            </div>
            <div className='flex-1 min-h-0 overflow-auto'>{children}</div>
            {footer && <div className='px-6 py-3 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3 flex-wrap'>{footer}</div>}
        </div>
    </div>
);

export default Modal;
